module.exports = __webpack_public_path__ + "static/media/logo-eu-inverted.16e7a266.svg";